import React, {useState} from 'react'
import {Selector} from "../../../components";


function FieldOptionsSelector({fieldObj, fieldIndex, multi, fieldUpdatedFunction, readOnly, singleLocationMode}) {
    const [options, setOptions] = useState(singleLocationMode || readOnly ? fieldObj.options : [])
    const [selected, setSelected] = useState([])

    const calcSelected = () => {
        const mySelected = options.filter(option => option.selected)
        return mySelected
    }


    const updateSelections = (selections) => {
        const selectedIndices = selections.map(option => option.optionId).map(optionId => options.findIndex(option => optionId == option.optionId))
        options.forEach(option => option.selected = false) //Switch them all to false
        selectedIndices.forEach(index => options[index].selected = true) //Now mark the selected ones
        setSelected(calcSelected())
        fieldUpdatedFunction(fieldObj)
    }
    const isDisabled = () => {
        if(readOnly){
            return true
        } else {
            singleLocationMode ? false : !fieldObj.bulkAllowed
        }
    }

    return <div>
        <Selector
            key={"MultiSelectField-" + fieldIndex}
            multi={multi}
            options={options}
            getKey={x => x.optionId}
            selected={calcSelected()}
            onSelected={optionsSelected => updateSelections(optionsSelected)}
            renderOption={x => <span>{x.optionDisplayName}</span>}
            disabled = {isDisabled()}
        />
    </div>


}

export default FieldOptionsSelector;